import { clsx } from 'clsx';

const TIPS = [
  {
    key: '1',
    icon: '✨',
    text: 'Access to all AI features',
    className: 'bg-[linear-gradient(90deg,#E5F1FE_0%,#E3F5FE_100%)]',
  },
  {
    key: '2',
    icon: '💬',
    text: '100 free AI responses',
    className: 'bg-[linear-gradient(90deg,#E3F5FE_0%,#E2FBF9_100%)]',
  },
  {
    key: '3',
    icon: '🛠',
    text: 'Instant testing and integration',
    className: 'bg-[linear-gradient(90deg,#E2FBF9_0%,#E7FFF1_100%)]',
  },
  {
    key: '4',
    icon: '👥',
    text: 'Unlimited team members',
    className: 'bg-[linear-gradient(90deg,#E7FFF1_0%,#EFFFE8_100%)]',
  },
  {
    key: '5',
    icon: '🤝',
    text: 'Priority support',
    className: 'bg-[linear-gradient(90deg,#EFFFE8_0%,#F6FFE8_100%)]',
  },
];

export const OnboardingStep7Title = () => {
  return (
    <div className={'w-full flex flex-col gap-7.5 items-center justify-center animate-fade-in'}>
      <div className={'w-full flex flex-col gap-2.5 items-center justify-center'}>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            className="m-auto"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20 40C22.6264 40 25.2272 39.4827 27.6537 38.4776C30.0802 37.4725 32.285 35.9993 34.1421 34.1421C35.9993 32.285 37.4725 30.0802 38.4776 27.6537C39.4827 25.2272 40 22.6264 40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 -3.9137e-08 20 0C14.6957 7.90407e-08 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40ZM19.4844 28.0889L30.5956 14.7556L27.1822 11.9111L17.6267 23.3756L12.6822 18.4289L9.54 21.5711L16.2067 28.2378L17.9267 29.9578L19.4844 28.0889Z"
              fill="#21DB5F"
            />
          </svg>
        </div>
        <div>
          <h1
            className={
              'capitalize font-jamjuree font-bold text-ebony text-[3.438rem] text-center leading-[120%]'
            }
          >
            Your AI Agent is ready
            <br /> to answer real customer questions
          </h1>
        </div>
      </div>
      <div className={'w-full flex flex-row flex-wrap items-center gap-1.5 justify-center'}>
        {TIPS.map((tip) => {
          return (
            <div
              key={tip.key}
              className={clsx(
                'flex flex-row gap-2.5 rounded-full py-2 px-4 text-ebony_opacity_80 font-medium text-base',
                tip.className,
              )}
            >
              <span>{tip.icon}</span>
              <span>{tip.text}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
